module.exports = __webpack_public_path__ + "static/7-ea6ded324f2e2763c35adf1882090ce2.jpg";